import {
  LISTA_FINANCEIRO_COSTCENTER,
  LISTA_FINANCEIRO_COSTCENTER_SUCCESSFUL,
  CADASTRAR_FINANCEIRO_COSTCENTER,
  CADASTRAR_FINANCEIRO_COSTCENTER_SUCCESSFUL,
  EDITAR_FINANCEIRO_COSTCENTER,
  EDITAR_FINANCEIRO_COSTCENTER_SUCCESSFUL,
  VIEW_FINANCEIRO_COSTCENTER,
  VIEW_FINANCEIRO_COSTCENTER_SUCCESSFUL,
} from './actionTypes';

const INIT_STATE = {
  error: '',
  costcenters: {
    data: {
      result: [],
      pagination: {
        start: 0,
        end: 0,
        total: 0,
      },
    },
    isLoading: true,
  },
  costcenter: {
    data: {
      result: [],
    },
    isLoading: true,
  },
  isSave: false,
};

const FinanceCostCenter = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_FINANCEIRO_COSTCENTER:
      return {
        ...state,
        costcenters: {
          data: {
            result: [],
            pagination: {
              start: 0,
              end: 0,
              total: 0,
            },
          },
          isLoading: true,
        },
      };
    case LISTA_FINANCEIRO_COSTCENTER_SUCCESSFUL:
      return {
        ...state,
        costcenters: {
          data: {
            result: action.payload.result,
            pagination: action.payload.pagination,
          },
          isLoading: false,
        },
      };
    case CADASTRAR_FINANCEIRO_COSTCENTER:
      return {
        ...state,
        isSave: false,
      };
    case CADASTRAR_FINANCEIRO_COSTCENTER_SUCCESSFUL:
      return {
        ...state,
        isSave: true,
      };
    case EDITAR_FINANCEIRO_COSTCENTER:
      return {
        ...state,
        isSave: false,
      };
    case EDITAR_FINANCEIRO_COSTCENTER_SUCCESSFUL:
      return {
        ...state,
        isSave: true,
      };
    case VIEW_FINANCEIRO_COSTCENTER:
      return {
        ...state,
        costcenter: {
          data: {
            result: [],
          },
          isLoading: true,
        },
      };
    case VIEW_FINANCEIRO_COSTCENTER_SUCCESSFUL:
      return {
        ...state,
        costcenter: {
          data: { result: action.payload },
          isLoading: false,
        },
      };
    default:
      return { ...state };
  }
};

export default FinanceCostCenter;
